import { userToast } from 'helpers/toastMessages';

export const headerData = {
  tableName: 'Users',
  hasExport: false,
  hasSearch: true,
  hasDelete: true,
  hasEdit: true,
  hasPaging: true,
  hasCheckbox: true,
  hasUploadCSV: false,
  hasLock: true,
  deleteSubtext: userToast.deleteConfirmation,
  fields: [
    {
      fieldName: 'groupName',
      headerName: 'Group Name',
      fontWeight: 500,
    },
    {
      fieldName: 'description',
      headerName: 'Description',
    },
    {
      fieldName: 'role',
      headerName: 'Role',
      hasTag: true,
    },
    {
      fieldName: 'members',
      headerName: 'Members',
    },
    {
      fieldName: 'createdAt',
      headerName: 'Created',
      isDatetime: true,
    },
  ],
};
